import { TimeRange } from "./TimeRange";
import {formatDateShort} from '@/utils/DateFormatter';
import { ClientPanelAssignment } from "./ClientPanelAssignment";

export interface ProjectAssignmentInfo extends TimeRange {
  projectName: string;
  projectNumber: string | null;
  contactPersonNumber: number | null;
  contactPersonName: string | null;
  clientId: string;
}

export interface ProjectAssignmentDetails extends ProjectAssignmentInfo {
  projectId: string;
  assignmentId?: string;
}

export function formatProjectAssignmentDetails(
  vue: Vue,
  assignmentDetails: ProjectAssignmentDetails | null,
  previousAssignmentDetails: null | ProjectAssignmentDetails,
  hideTimeRange?: boolean
) {
  let runAssignmentInfo: string | undefined = undefined;

  if (previousAssignmentDetails && !assignmentDetails) {
    runAssignmentInfo = vue.$t(
      "panelDetail.runInfo.runNotAssigned"
    ).toString();
  } else if (
    assignmentDetails &&
    (!previousAssignmentDetails ||
      previousAssignmentDetails.projectId != assignmentDetails.projectId ||
      previousAssignmentDetails.contactPersonNumber !=
      assignmentDetails.contactPersonNumber)
  ) {
    let apartmentInfo = "";

    if (assignmentDetails.contactPersonNumber) {
      apartmentInfo = vue.$t("clientData.formatApartment", [
        assignmentDetails.contactPersonNumber,
      ]).toString();

      if (assignmentDetails.contactPersonName) {
        apartmentInfo += " / " + assignmentDetails.contactPersonName;
      }

      apartmentInfo = " (" + apartmentInfo + ")";
    }

    const projectName = assignmentDetails.projectName + apartmentInfo;

    if (hideTimeRange) {
      return projectName
    }

    if (assignmentDetails.endDate) {
      runAssignmentInfo = vue.$t("panelDetail.runInfo.runAssigned", [
        projectName,
        formatDateShort(assignmentDetails.startDate),
        formatDateShort(assignmentDetails.endDate),
      ]).toString();
    } else {
      runAssignmentInfo = vue.$t(
        "panelDetail.runInfo.runAssignedOpenEnded",
        [projectName, formatDateShort(assignmentDetails.startDate)]
      ).toString();
    }
  }

  return runAssignmentInfo;
}

export function mapClientPanelAssignmentToProjectAssignmentDetails(
  clientPanelAssignment: ClientPanelAssignment
) {
  return {
    assignmentId: clientPanelAssignment.id,
    projectId: clientPanelAssignment.assignedProjectId,
    projectName: clientPanelAssignment.assignedProjectName,
    projectNumber: clientPanelAssignment.assignedProjectNumber,
    clientId: "",
    startDate: clientPanelAssignment.assignmentStartDate,
    endDate: clientPanelAssignment.assignmentEndDate,
    contactPersonNumber: null,
    contactPersonName: null,
  } as ProjectAssignmentDetails;
}

export function getProjectAssignmentDetailsFromClientPanelAssignments(
  assignmentId: string | undefined | null,
  clientPanelAssignments: ClientPanelAssignment[]
) {
  if (!assignmentId) {
    return null;
  }

  const clientPanelAssignment = clientPanelAssignments.find((assignment) => {
    return assignment.id === assignmentId
  })

  if (!clientPanelAssignment) {
    return null;
  }

  return mapClientPanelAssignmentToProjectAssignmentDetails(clientPanelAssignment);
}
